define(
    "diy/undo-redo/executor/Client",
    [
        'diy/undo-redo/executor/Base',
        'diy/undo-redo/ExecutedEntry',
        'diy/undo-redo/constants'
    ],
    /**
     *
     * @param {module.undoRedo.Executor.Base} Base
     * @param {module.undoRedo.ExecutedEntry} ExecutedEntry
     * @param {module.undoRedo.constants} constants
     * @returns {*}
     */
    function (Base, ExecutedEntry, constants) {
        'use strict';
        var ExecutorClient;

        /**
         * @class module.undoRedo.Executor.Client
         * @template module.undoRedo.Executor.Client
         * @lends {module.undoRedo.Executor.Client.prototype}
         * @extends {module.undoRedo.Executor.Base}
         * @constructor
         */
        ExecutorClient = Base.extend({


            type: constants.executionType.CLIENT,

            /**
             *
             * For server entries ww will execute only the last entry from set (the server will execute the intermediary
             *  entries to keep the chain complete
             *
             * @param {Array.<module.undoRedo.Entry>} items
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {Boolean} hasLastEntry
             * @returns {*}
             */
            executeSet: function executeSet(items, result, hasLastEntry) {
                var
                    setPromises = [],
                    identitySets,
                    lastSet,
                    executedEntryKey;

                identitySets = this.groupEntriesByIdentity(items);
                lastSet = identitySets[identitySets.length - 1];

                executedEntryKey = lastSet.items[lastSet.items.length - 1].getKey();

                identitySets.forEach(function (identitySet) {
                    setPromises.push(function () {
                        return this.executeIdentitySet(identitySet, result, (hasLastEntry ? executedEntryKey : null));
                    }.bind(this));
                }.bind(this));

                return setPromises.reduce(Q.when, Q(true));
            },
            /**
             *
             * @param {{identity:String, items:Array.<module.undoRedo.Entry>}} identitySet
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param lastEntryKey
             */
            executeIdentitySet: function executeIdentitySet(identitySet, result, lastEntryKey) {
                var toExecute = [];

                if (identitySet.identity === null) {
                    /** for non mergeable entries execute them sequentially */
                    identitySet.items.forEach(function (entry, index, array) {
                        toExecute.push(function () {
                            return this.executeNonMergeableEntry(entry, index, array, result, lastEntryKey);
                        }.bind(this));
                    }.bind(this));
                } else {
                    /** for full snapshots:
                     *  - save current state
                     *  - move entries to the other chain (switch payload between them)
                     *  - execute last entry if requested or in REDO queue
                     */

                    var
                        entryToExecute = identitySet.items[identitySet.items.length - 1],
                        beforeExecutionState;

                    /** create snapshot of the current state */
                    toExecute.push(function () {
                        var deferred = Q.defer();
                        entryToExecute.createSnapshot()
                            .then(function (previousState) {
                                beforeExecutionState = previousState;
                                deferred.resolve(previousState);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                        return deferred.promise;
                    });

                    /** move entries to the other chain; payload will be switched by one step */
                    identitySet.items.forEach(function (entry, index, array) {
                        toExecute.push(function () {
                            var payload;
                            if (index === 0) {
                                payload = beforeExecutionState;
                            } else {
                                payload = array[index - 1].getPayload();
                            }
                            return this.history.switchChains(entry, payload);
                        }.bind(this));
                    }.bind(this));


                    // apply last entry in chain
                    toExecute.push(function (){
                        return entryToExecute.applySnapshot();
                    });

                    /** if execute entry if is in REDO or user explicitly asked for it */
                    if (entryToExecute.getType() === constants.types.REDO || entryToExecute.getKey() === lastEntryKey) {
                        toExecute.push(function(){
                            var deferred = Q.defer();
                            entryToExecute.submit()
                                .then(function (res) {
                                    var executedEntry = new ExecutedEntry();
                                    if (entryToExecute.getKey() === lastEntryKey) {
                                        executedEntry.setOnExecutedLast(entryToExecute.onExecutedLast.bind(entryToExecute));
                                        result.push(executedEntry);
                                    }
                                    deferred.resolve(res);
                                })
                                .catch(function (err) {
                                    deferred.reject(err);
                                });
                            return deferred.promise;
                        });
                    }
                }
                return toExecute.reduce(Q.when, Q(result));
            },
            /**
             *
             * @param {module.undoRedo.Entry} entry
             * @param {Number} index
             * @param {Array.<module.undoRedo.Entry>} array
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {String=} callToExecutionKey
             * @returns {Promise|Q.promise}
             */
            executeNonMergeableEntry: function executeNonMeargeableEntry(entry, index, array, result, callToExecutionKey) {
                var steps = [], createdSnapshot;

                steps.push(function executeEntry(snapshot) {
                    var deferred = Q.defer();
                    createdSnapshot = snapshot;
                    entry.execute(entry.getKey() === callToExecutionKey && entry.getLinkedEntryId() === 0)
                        .then(function () {
                            var executedEntry = new ExecutedEntry();
                            if (callToExecutionKey === entry.getKey()) {
                                executedEntry.setOnExecutedLast(entry.onExecutedLast.bind(entry));
                            }
                            result.push(executedEntry);

                            deferred.resolve(createdSnapshot);
                        })
                        .catch(function (err) {
                            deferred.reject(err);
                        });
                    return deferred.promise;
                });

                steps.push(function syncEntry(previousState) {
                    return this.history.switchChains(entry, previousState);
                }.bind(this));

                return steps.reduce(Q.when, entry.createSnapshot());
            },

            groupEntriesByIdentity: function (chain) {
                return chain.reduce(function (previous, current) { //, index, array) {
                    var
                        lastElement = previous[previous.length - 1],

                        newSection = function (previous, current) {
                            var object = {};
                            object.identity = current.getIdentity();
                            object.items = [current];
                            previous.push(object);
                        };

                    if (!lastElement) {
                        newSection(previous, current);
                    } else {
                        if (lastElement.identity === current.getIdentity() && current.getIdentity() !== null) {
                            lastElement.items.push(current);
                            previous[previous.length - 1] = lastElement;
                        } else {
                            newSection(previous, current);
                        }
                    }

                    return previous;
                }, []);
            }
        });

        return ExecutorClient;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/executor/Client.js
 ** module id = 918
 ** module chunks = 0
 **/